<template>
  <div class="w-full h-full overflow-hidden">
    <!-- <Step class="mb-40px" :steps="steps" v-model="step" /> -->
    <el-form
      class="w-800px m-auto my-0"
      :model="modelForm"
      :rules="rules"
      ref="ruleForm"
      v-if="step == 0"
      :before-close="close"
    >
    <el-form-item label="部署方式" required >
        <el-radio v-model="jingxiangstatus" :label="1" @input="radioChange"  :disabled="isrestart"
          >模型镜像</el-radio
        >
        <el-radio v-model="jingxiangstatus" :label="2" @input="radioChange" v-if="!checkImg && !isrestart"  :disabled="isrestart"
          >自定义URL</el-radio
        >
      </el-form-item>
      <el-form-item
        label="选择镜像"
        prop="image_version_biz_id"
        v-if="jingxiangstatus == 1 && checkImg"  
        
      >
      <!-- 部署方式位模型镜像，并且传了选中镜像，常规镜像选择 -->
      <el-select v-model="checkImg[0].image_version_biz_id" placeholder="请选择" disabled v-if="correlation<2">
          <el-option :label="checkImg[0].image_name" :value="checkImg[0].image_version_biz_id"></el-option>
        </el-select>

        <el-select v-model="checkImg.image_version_biz_id" :placeholder="checkImg.image_name" v-if="correlation>1" :disabled="isrestart">
          <el-option
            v-for="(item, index) in checkImg"
            :key="index"
            :label="item.image_name"
            :value="item.image_version_biz_id"
            @click.native="imageChange(item ,'image')"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="选择镜像"
        prop="image_version_biz_id"
        v-if="jingxiangstatus == 1 && !checkImg && !checked"
        style="position: relative;"
      >
       <!-- 部署方式位模型镜像，并且传了没有选中镜像，并且位公开镜像，不勾选自定义镜像 -->
        <el-select v-model="modelForm.image_version_biz_id" filterable placeholder="请选择镜像" :disabled="isrestart">
          <el-option
            v-for="(item, index) in imgOptions"
            :key="index"
            :label="item.image_name"
            :value="item.image_version_biz_id"
            @click.native="imageChange(item,'image')"
          ></el-option>
        </el-select>
        <el-checkbox v-model="checked" style="position: absolute; right: -0.6rem;" @change="checkuserimage" :disabled="isrestart">自定义镜像</el-checkbox>    
      </el-form-item>
      <el-form-item
        label="选择镜像"
        prop="image_version_biz_id"
        v-if="jingxiangstatus == 1 && !checkImg && checked"
        style="position: relative;"
      >
      <!-- 部署方式位模型镜像，并且传了没有选中镜像，并且未公开镜像，勾选自定义镜像 -->
      <el-select v-model="modelForm.image_version_biz_id" filterable placeholder="请选择自定义镜像" :disabled="isrestart">
          <el-option
            v-for="(item, index) in userimagelist"
            :key="index"
            :label="item.image_name"
            :value="item.image_version_biz_id"
            @click.native="imageChange(item,'userimage')"
          ></el-option>
        </el-select>
        <el-checkbox v-model="checked" style="position: absolute; right: -0.6rem;" @change="checkuserimage" :disabled="isrestart">自定义镜像</el-checkbox>
    </el-form-item>
      <el-form-item label="硬件配置" prop="xpu_id" v-if="jingxiangstatus == 1">
        <el-select v-model="modelForm.xpu_id" placeholder="请选择">
          <el-option
            v-for="(item, index) in xpuList"
            :key="index"
            :label="item.xpu_name"
            :value="item.id"
            @click.native="xpuChange(item)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="URL地址"
        prop="model_image_link"
        v-if="jingxiangstatus == 2"
      >
        <el-input v-model="modelForm.model_image_link" maxlength="100">
        </el-input>
      </el-form-item>
      <el-form-item
        label="页面类型"
        prop="page_type"
        v-if="jingxiangstatus == 2"
      >
        <el-radio v-model="modelForm.page_type" label="Gradio">Gradio</el-radio>
        <el-radio v-model="modelForm.page_type" label="Streamlit"
          >Streamlit</el-radio
        >
        <el-radio v-model="modelForm.page_type" label="Custom">Custom</el-radio>
      </el-form-item>
      <el-form-item label="名称" prop="serving_name_zh">
        <el-input
          v-model="modelForm.serving_name_zh"
          maxlength="100"
          show-word-limit
          :disabled="isrestart"
        />
      </el-form-item>
      <!-- <el-form-item label="英文名称" prop="serving_name_en">
        <el-input
          v-model="modelForm.serving_name_en"
          maxlength="100"
          show-word-limit
        />
      </el-form-item> -->
      <el-form-item label="类型" prop="serving_category_id">
        <select-model-type
          v-model="modelForm.serving_category_id"
          :props="{ expandTrigger: 'hover' }"
          :options="typeList"
          :disableds="isrestart"
        ></select-model-type>
      </el-form-item>
      <el-form-item label="发布者" prop="publisher_id">
        <el-select v-model="modelForm.publisher_id" @visible-change="visiblechange" :disabled="isrestart">
          <el-option
            v-for="(item, index) in ownerOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
            
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否公开" prop="is_public">
        <el-radio
          v-model="modelForm.is_public"
          v-for="item in $store.state.selectOptions.isOpen"
          :key="item.id"
          :label="item.id"
          >{{ item.name }}</el-radio
        >
        <span class="ml-0.1rem">
        * 私有服务 请到'用户中心-我的资源-体验'中查看
        </span>
      </el-form-item>
      
    </el-form>
    <div class="w-800px m-auto my-0 " v-if="showprice">
      <el-form
      class="w-800px m-auto my-0"
      :model="modelForm"
      :rules="rules"
      ref="ruleForms"
      v-if="step == 0"
      :before-close="close"
    >
      <el-form-item label="计费方式" prop="xpu_price_conf_id">
        <el-radio
          v-model="modelForm.xpu_price_conf_id"
          v-for="item in payList"
          :key="item.id"
          :label="item.id"
          @input="payChange(item)"
          >{{ item.type_name }}</el-radio
        >
      </el-form-item>
      <el-form-item label="配置费用" >
        <div  style="color: #333333; font-size: 0.1rem;">{{ payfee }}元/{{ payUnit }}</div>
        <el-popover
            placement="right"
            title="提示"
            width="340"
            trigger="hover"
            v-show="!showTime"
          >
            <div>
              快到期时可以到“用户中心-我的资源-体验”中进行续费<br />
              预付费资源暂时不支持手动停止
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
      </el-form-item>
      <el-form-item label="停止时间" prop="time_range_id" v-show="showTime">
        <el-select v-model="modelForm.time_range_id" placeholder="请选择">
            <el-option
              v-for="(item, index) in timeRangeList"
              :key="index"
              :label="item.time_range_desc"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-popover
            placement="right"
            title="提示"
            width="340"
            trigger="hover"
          >
            <div>
              您可以到"用户中心-我的资源-体验"中随时停止<br />
              体验运行中将每小时自动从账户余额中扣除相应费用
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
        </el-form-item>
        <el-form-item label="账户余额" >
          <span style="color: #333333; font-size: 0.1rem;">￥{{ belence }}</span>
          <div class="flex items-center ml-20px" v-if="noMony">
            <img src="@/assets/images/warning.png" class="warning-icon" />
            <span class="money-warning">余额不足，请充值</span>
            <div class="ml-10px pay-btn" @click="pay">充值</div>
            <div class="ml-10px pay-btn" @click="flushAccount">刷新</div>
          </div>
        </el-form-item>
  </el-form>

    </div>
    <div class="flex footer">
      <el-button
        type="primary"
        @click="nextFn"
        v-if="jingxiangstatus == 2"
        :disabled="disable"
        >确认</el-button
      >
      <!-- <el-button type="primary" @click="backFn" v-if="step == 1"
        >上一步</el-button
      > -->
      <el-button
        type="primary"
        v-if="jingxiangstatus == 1"
        :disabled="disable || noMony"
        @click="finishFn"
        data-umami-event="新建体验-提交订单"
        >提交订单</el-button
      >
    </div>
    <el-dialog
      title=""
      append-to-body
      :visible.sync="modelVisible"
      width="7rem"
      :before-close="closeModel"
    >
      <div class="flex flex-col">
        <payMent @close_pay="closeModel" class="p-50px"></payMent>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPublisher } from '@/utils/getSelectOptions'
import payMent from '@/views/individual-center/my-account/payment/payment.vue'
import selectModelType from '@/components/select-model-type.vue'
import Step from '@/components/step.vue'
import { valiEngName } from '@/utils/validate'
import getFullByLastIdFromTree from '@/utils/getFullByLastIdFromTree'
import array2Tree from '@/utils/arrayToTree'
export default {
  components: { selectModelType, Step, payMent },
  props: {
    checkImg: {} ,//从模型详情页面创建默认选中一个镜像
    correlation:{}
  },
  data() {
    const engNameValidate = (rule, value, callback) => {
      const { status, message } = valiEngName(value)

      if (!status) {
        callback(message)
      } else {
        callback()
      }
    }
    return {
      xpuList:[],
      modelVisible: false,
      disable: false,
      jingxiangstatus: 1,
      step: 0,
      isrestart: false,//是否为重新启动，重新启动禁用部分输入内容
      showprice: false,//显示计费信息
      steps: [
        { iconClass: 'jcxx', name: '基础信息' },
        { iconClass: 'szsx', name: '确认订单' }
      ],
      rules: {
        serving_name_zh: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        // serving_name_en: [
        //   {
        //     required: true,
        //     message: '请填写英文名称',
        //     validator: engNameValidate,
        //     trigger: 'blur'
        //   }
        // ],
        serving_category_id: [
          { required: true, message: '请选择模型类型', trigger: 'change' }
        ],
        publisher_id: [
          { required: true, message: '请选择发布者', trigger: 'change' }
        ],
        is_public: [
          { required: true, message: '请选择是否公开', trigger: 'change' }
        ],
        image_version_biz_id: [
          { required: true, message: '请选择镜像', trigger: 'change' }
        ],
        xpu_price_conf_id: [{ required: true, message: '选择计费方式', trigger: 'change' }],
        xpu_id: [{ required: true, message: '请选择硬件配置', trigger: 'change' }],
        model_image_link:[{ required: true, message: '请填写URL', trigger: 'blur' }],
        page_type:[{ required: true, message: '选择页面类型', trigger: 'change' }],

      },
      paymethod: '',
      payfee: '',
      payList: [],
      userimagelist:[],//用户私有镜像列表
      checked:false,//是否勾选自定义镜像
      modelForm: {
        serving_name_zh: '',
        // serving_name_en: '',
        serving_category_id: '',
        publisher_id: '',
        is_public: 1,
        page_type: '',
        model_image_link: '',
        xpu_id: '',
        time_range_id: '',
        jingxiangstatus:'部署方式',
        image_version_biz_id:'',//镜像版本id
        xpu_price_conf_id: '',//硬件配置id
      },
      selectImageName: '',
      selectXpuName: '',
      belence: '',
      payUnit: '',
      noMony: false,
      showTime: false,
      typeList: [],
      image_base_lm_type:''
    }
  },
  computed: {
    ownerOptions() {
      return this.$store.state.selectOptions.owner
    },
    imgOptions() {
      return this.$store.state.selectOptions.modelImages
    },
    timeRangeList() {
      return this.$store.state.selectOptions.timeRangeList
    },
    XPUInfoList() {
      return this.$store.state.selectOptions.XPUInfoList
    }
  },
  watch: {
   
  },
  created() {
    getPublisher()
    this.initialization()
  },
  mounted() {
 
    let data = {
  
    }
    this.$api.project.getAccountInfo(data).then((res) => {
      this.belence = res.data.account_remain_amount
    })

    let list = this.$store.state.selectOptions.ServerTypeList
    const arr = list.map((item) => {
      return {
        label: item.name,
        value: item.id,
        pid: item.pid
      }
    })
    const tree = array2Tree(arr, {
      id: 'value',
      parentId: 'pid',
      children: 'children'
    })
    this.typeList = tree
  },
  methods: {
    nextFn() {
      this.flushAccount()
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (
            this.jingxiangstatus == 1 &&
            this.modelForm.image_version_biz_id == '' &&
            this.checked == false
          ) {
            alert('请选择镜像')
            return
          }
          if (this.jingxiangstatus == 1 && this.modelForm.xpu_id == '') {
            alert('请选择硬件配置')
            return
          }
          if (
            this.jingxiangstatus == 2 &&
            this.modelForm.model_image_link == ''
          ) {
            alert('请输入镜像地址')
            return
          }
          if (this.jingxiangstatus == 2 && this.modelForm.page_type == '') {
            alert('请选择页面类型')
            return
          }
          if (this.jingxiangstatus == 2) {
            this.finishFn()
          }
        }
      })
    },
    backFn() {
      this.step = 0
    },
    checkuserimage(val){
      this.modelForm.image_version_biz_id = ''
      this.modelForm.xpu_id = ''
      this.modelForm.image_version_biz_id=''

        if(val){
            let data ={
              image_type:'deploy'
            }
            this.$api.project.getUserImagesName(data).then(res =>{
                this.userimagelist = [...res.data]
            })
        }
      
    },
    initialization(){
      if (this.jingxiangstatus == 1 && Array.isArray(this.checkImg) && this.correlation<2) {
      this.modelForm.image_version_biz_id=this.checkImg[0].image_version_biz_id
      this.selectImageName = this.checkImg[0].image_name
      let data={
        biz_id:this.checkImg[0].image_version_biz_id
      }
      this.$api.project.getXPUInfosByImageVersionBizId(data).then((res)=>{
        this.xpuList=[...res.data]
        this.modelForm.xpu_id=''
        this.modelForm.xpu_id=''
        if(this.xpuList.length==1){
          this.modelForm.xpu_id = this.xpuList[0].id
          this.xpuChange(this.xpuList[0])
        }
      })
    }
    },
 
    finishFn() {
      this.flushAccount()
     
      this.$refs['ruleForm'].validate((valid) => {
     if(valid){
      if(this.isrestart){
        this.$emit('finish',this.modelForm)
        return
      }
      if (this.jingxiangstatus == 1 && this.modelForm.time_range_id == '') {
        this.modelForm.time_range_id = 0
      }
      if (this.jingxiangstatus == 2) {
        this.modelForm.image_version_biz_id = ''
        this.modelForm.xpu_id = 0
        this.modelForm.time_range_id = 0
        this.modelForm.xpu_price_conf_id = 0
      }
      if (this.modelForm.serving_category_id.length > 0) {
        this.modelForm.serving_category_id =
          this.modelForm.serving_category_id.slice(-1)[0]
      }
      if(this.checked){
        this.modelForm.image_version_biz_id = ''
      }
      this.modelForm.creator_id = this.$store.state.system.userInfo.userid
      this.disable = true
      this.$api.project.createModelServing(this.modelForm).then((res) => {
        this.disable = false
        if (res.code == 0) {
          this.$message.success('创建成功')
          this.$emit('finish')

          this.step = 0
          // this.modelForm[prop] = ''
          for (let prop in this.modelForm) {
            if (this.modelForm.hasOwnProperty(prop)) {
              this.modelForm[prop] = '' // 或者其他初始值
            }
          }
        }
      })
    }
    })
    },
    radioChange(e) {
      if (e == '1') {
        this.modelForm.model_image_link = ''
        this.xpuList=[]
      }
      if (e == '1' && this.checkImg) {
        this.modelForm.image_version_biz_id = this.checkImg.image_version_biz_id
      }
      if (e == '2' && !this.checkImg) {
        this.modelForm.image_version_biz_id = ''
      }
      if (e == '2') {
        this.modelForm.xpu_id = ''
        this.showprice = false
      }
      this.modelForm.page_type=''
      this.$refs.ruleForm.clearValidate(['xpu_id', 'model_image_link','image_version_biz_id','page_type']);
    },
    imageChange(e,image_type) {  
      this.modelForm.image_version_biz_id = e.image_version_biz_id     
      this.$refs.ruleForm.clearValidate(['image_version_biz_id']);
      this.modelForm.xpu_id = ''
      this.selectImageName = e.image_name
      //images查询选中的镜像对应的image_base_lm_type
      this.showprice = false
      if(image_type==='image'){
        let images = this.imgOptions.filter(item => item.image_version_biz_id === e.image_version_biz_id);
        this.image_base_lm_type=images[0].image_base_lm_type
        let data={
          biz_id:e.image_version_biz_id,
      }
      this.$api.project.getXPUInfosByImageVersionBizId(data).then((res)=>{
        this.xpuList=[...res.data]
        this.modelForm.xpu_id=''
        if(this.xpuList.length==1){
          this.modelForm.xpu_id = this.xpuList[0].id
          this.xpuChange(this.xpuList[0])
        } 
        if(e.xpu_id){
            let hasxpu = this.xpuList.findIndex(item => item.id === e.xpu_id);
            if(hasxpu>=0){
              this.modelForm.xpu_id = e.xpu_id
              this.xpuChange(this.xpuList[hasxpu])
            }
        }
      }) 
      }else{
        this.image_base_lm_type=''
        let data ={
          biz_id:e.biz_id
        }
        this.$api.project.getXPUInfosByImageVersionBizId(data).then((res)=>{
            this.xpuList=[...res.data]
            this.modelForm.xpu_id=''
            if(this.xpuList.length==1){
              this.modelForm.xpu_id = this.xpuList[0].id
              this.xpuChange(this.xpuList[0])
            }
        })
      }  
      this.$refs.ruleForm.validateField(['xpu_id'])
      this.imagesSelect(e) 
    },
    //发布者下拉列表
    visiblechange(){
      
    },
    xpuChange(e) {
      this.selectXpuName = e.xpu_name
      let data = {
        xpu_id: e.id,
        is_share_res:1,
        image_base_lm_type:this.image_base_lm_type
      }
      this.$api.project.getxpuCharg(data).then((res) => {
        this.payList = res.data
        this.modelForm.xpu_price_conf_id = res.data[0].id
        this.payfee = res.data[0].price
        this.showprice = true
        if (res.data[0].type_name_en == 'flow') {
          this.showTime = true
          this.payUnit = '小时'
        }
        if (res.data[0].type_name_en == 'day') {
          this.payUnit = '天'
        }
        if (res.data[0].type_name_en == 'week') {
          this.payUnit = '周'
        }
        if (res.data[0].type_name_en == 'month') {
          this.payUnit = '月'
        }
        if (res.data[0].type_name_en == 'year') {
          this.payUnit = '年'
        }
        if (this.belence < this.payfee) {
          this.noMony = true
        }
      })
    },
    payChange(e) {
      this.payfee = e.price
      this.payUnit = e.type_name_en
      if (this.belence < e.price) {
        this.noMony = true
      } else {
        this.noMony = false
      }
      if (e.type_name_en == 'flow') {
        this.showTime = true
        this.payUnit = '小时'
      } else {
        this.showTime = false
      }
      if (e.type_name_en == 'day') {
        this.payUnit = '天'
      }
      if (e.type_name_en == 'week') {
        this.payUnit = '周'
      }
      if (e.type_name_en == 'month') {
        this.payUnit = '月'
      }
      if (e.type_name_en == 'year') {
        this.payUnit = '年'
      }
    },
    //镜像广场模块imagespaces选中镜像调用方法
    imagesSelect(e)
    {
        //e为镜像广场模块imagespaces传值      
        this.modelForm.publisher_id = this.ownerOptions[0].id
        this.modelForm.serving_name_zh = this.processString(e.image_name)
        if(e.category_id!==0){
          let modelType = getFullByLastIdFromTree(
              this.$store.state.selectOptions.ServerTypeList,
              e.category_id
             )
        this.modelForm.serving_category_id=modelType
        }else{
          this.modelForm.serving_category_id=''
        }
    },
    //服务重启调用方法
    restartModel(info) {
      this.imageChange(info,'image')
      this.modelForm.serving_category_id = [info.serving_parent_category_id,info.serving_category_id]
      this.isrestart = true
      this.$nextTick(() => {
        this.modelForm.serving_name_zh = info.serving_name_zh
        this.modelForm.publisher_id = info.publisher_id
        if(info.is_public){
          this.modelForm.is_public = 1
        }else{
          this.modelForm.is_public = 0
        }
      })

    },
    processString(str) {
        const index = str.indexOf('/');
        if (index !== -1) {
          return str.slice(index + 1);
        }
        return str;
      },
    pay() {
      this.modelVisible = true
    },
    closeModel() {
      this.modelVisible = false
    },
    close() {
      this.step = 0
      this.checked=false
      this.isrestart = false
      this.showprice = false   
        this.$refs.ruleForm.resetFields()
        this.modelForm.image_version_biz_id=''
        this.modelForm.xpu_price_conf_id=''
        this.modelForm.serving_name_zh=''
        this.$nextTick(() => {
           this.$refs.ruleForm.clearValidate()     
        })
    },
    //关闭弹窗
    closeModel() {
      this.modelVisible = false
    },
   
    flushAccount() {
      let data = {
   
      }
      this.$api.project.getAccountInfo(data).then((res) => {
        this.belence = res.data.account_remain_amount
        if (this.belence >= this.payfee) {
          this.noMony = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.items {
  margin-bottom: 20px;
  font-size: 18px;
  color: #000;
}

.money-warning {
  color: #dd1d1d;
}

.warning-icon {
  width: 20px;
}

.pay-btn {
  border-radius: 5px;
  padding: 2px 10px;
  background: #dd1d1d;
  color: #fff;
  cursor: pointer;
}

.footer {
  height: 60px;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f4e9ff;
}

::v-deep {
  .el-input .el-input__inner {
    height: auto;
  }
}

</style>
